/* Enhancement only: Shopify's native contact form handles submissions. */
(() => {
  function getRoot(node) { return node && node.closest && node.closest('[data-leap-root]'); }
  function updateSocial(root) {
    if (!root) return;
    const yes = root.querySelector('[data-leap-content-radio][value="Yes"]');
    const social = root.querySelector('[data-leap-social]');
    if (!social) return;
    const visible = Boolean(yes && yes.checked);
    social.hidden = !visible;
    social.querySelectorAll('input,select,textarea').forEach(el => { el.disabled = !visible; });
  }
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-leap-content-radio]')) updateSocial(getRoot(event.target));
  });
  document.addEventListener('click', (event) => {
    const add = event.target.closest('[data-leap-add-profile]');
    if (add) {
      const root = getRoot(add);
      const list = root && root.querySelector('[data-leap-profile-rows]');
      const template = root && root.querySelector('[data-leap-profile-template]');
      if (!list || !template || list.children.length >= 5) return;
      const n = Number(root.dataset.leapNextProfile || 1);
      root.dataset.leapNextProfile = String(n + 1);
      const holder = document.createElement('div');
      holder.innerHTML = template.innerHTML.replace(/__N__/g, String(n)).trim();
      const row = holder.firstElementChild;
      if (row) list.appendChild(row);
      if (list.children.length >= 5) add.hidden = true;
      return;
    }
    const remove = event.target.closest('[data-leap-remove-profile]');
    if (remove) {
      const root = getRoot(remove);
      const row = remove.closest('.leap-profile-row');
      if (row) row.remove();
      const button = root && root.querySelector('[data-leap-add-profile]');
      if (button) button.hidden = false;
    }
  });
  function init(root) { root.querySelectorAll('[data-leap-social] input, [data-leap-social] select').forEach(el => { el.disabled = true; }); updateSocial(root); }
  document.addEventListener('DOMContentLoaded', () => document.querySelectorAll('[data-leap-root]').forEach(init));
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-leap-root]').forEach(init));
})();
